import React from 'react';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import PropTypes from 'prop-types';
import { downloadURI } from '../../lib/fileUtils';
import DocumentHelper from '../helpers/DocumentHelper';
import { DOC_TYPE_PDF_FORM } from './utils';
import printJS from 'print-js';

export default function withDocumentExport(WrappedComponent) {
  // eslint-disable-next-line no-undef
  class WrapperClass extends React.Component {
    getPdfDownloadLink = async docId => {
      let pdfUrl = '';
      await PaperflyAPI.getPdfDownloadLink(this.props.recipientRequestId, [
        docId
      ]).then(
        response => (pdfUrl = response.pdfUrl),
        error => console.log(error)
      );
      return pdfUrl;
    };

    doPrintDocument = async docId => {
      const document = this.props.requestedDocuments.find(
        doc => doc.id === docId
      );
      if (document.type === DOC_TYPE_PDF_FORM) {
        const pdfUrl = await this.getPdfDownloadLink(docId);
        if (pdfUrl) {
          printJS(pdfUrl);
        } else {
          this.doPrintDocumentAttachments(document);
        }
      } else {
        this.doPrintDocumentAttachments(document);
      }
    };

    doPrintDocumentAttachments = document => {
      printJS({
        maxWidth: 2000,
        documentTitle: ' ',
        printable: document.attachment,
        type: 'image',
        imageStyle: 'max-width: 99%;max-height: 99%;object-fit: contain;'
      });
    };

    doDownloadDocument = async docId => {
      const document = this.props.requestedDocuments.find(
        doc => doc.id === docId
      );

      if (document.type === DOC_TYPE_PDF_FORM) {
        const pdfUrl = await this.getPdfDownloadLink(docId);
        if (pdfUrl) {
          downloadURI(pdfUrl, document.name + '.zip');
        } else {
          this.doDownloadDocumentAttachments(document);
        }
      } else {
        this.doDownloadDocumentAttachments(document);
      }
    };

    doDownloadDocumentAttachments = document => {
      const docHelper = new DocumentHelper(
        document.attachment.map(attach => ({
          url: attach
        })),
        document.name
      );
      //docHelper.convertPagesToDataUrls(() => docHelper.download());
      docHelper.download();
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          doDownloadDocument={this.doDownloadDocument}
          doPrintDocument={this.doPrintDocument}
        />
      );
    }
  }

  WrapperClass.propTypes = {
    recipientRequestId: PropTypes.string,
    requestedDocuments: PropTypes.array
  };

  return WrapperClass;
}
